import {activeColors, borderRadius, buttonColors, colors, fontsSize, shadows} from "../Components/UIElements/Elements"

const TableCategory = ({ name, active, onClick }) => {
    return (
        <div
            className={`text-white relative m-[0.25%] w-auto px-[1.5vw] py-[1vw] max-lg:px-[1.5vh] max-lg:py-[1vh] h-[auto] flex justify-center items-center ${shadows.sm}
             ${borderRadius.medium} ${active ? activeColors.secondary : buttonColors.secondary} max-lg:h-[5vh] max-lg:rounded-lg ${fontsSize.m}`} onClick={onClick}>
            {name}
        </div>
    );
};

export default TableCategory;
